import {
    Configuration,
    DispatchRoute
  } from '../../../../../core';

  export const dispatchRoute = {
    searchText: '',
    addText: 'Crear ruta',
    secondaryButtonText: 'Edición masiva',
    secondaryButtonIcon: 'edit',
    export: false,
    filter: false,
    paginator:true,
    filterDefault: 'TD',
    checkbox: true,
    disabled: false,
    partialField: '',
    columns: [
      {
        title: 'Entidad de origen',
        name: 'origin',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: DispatchRoute) => element.origin.entityName
      },
      {
        title: 'Zona de destino',
        name: 'destination',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: DispatchRoute) => element.destiny.name
      },
      {
        title: 'Tipos de despacho',
        name: 'dispatchTypes',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: DispatchRoute) => {
          if (element.dispatchTypes.length && element.dispatchTypes[0].name) {
            return element.dispatchTypes
              .map(
                dispatchType =>
                  dispatchType.name +
                  (dispatchType.time >= 0 ? ' ( ' + dispatchType.time + 'd )' : '')
              )
              .join(' / ');
          } else {
            return '';
          }
        }
      },
      {
        title: 'Activo',
        name: 'active',
        type: 'boolean',
        editable: true,
        checkAll: false,
        class: 'center',
        value: (element: Configuration) => element.active
      }
    ],
    subTable: {}
  };
